/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { useSubscription } from "./useSubscription";
import { UomControl } from "../controls/UomControl";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <UomControl />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="table" />
        </ReportGrid>
      </div>
    </>
  );
}
